module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help",
    scopedSlots: _vm._u([{
      key: "modalButtons",
      fn: function(props) {
        return [_c('app-button', {
          attrs: {
            "text": _vm.showModalButtons ? _vm.$t('functional.noThanks') : _vm.$t('functional.close'),
            "iconName": "times",
            "action": props.close
          }
        })]
      }
    }])
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": _vm.$t('help.isThisLegal'),
      "property": "is-this-legal",
      "id": "1",
      "iconName": "pencil",
      "isActive": "true"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('help.isThisLegal')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('help.legalityInfo')))])]), _vm._v(" "), _c('tab', {
    attrs: {
      "name": _vm.$t('help.whatIsSignable'),
      "property": "what-is-signable",
      "id": "2",
      "iconName": "question"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('help.signableDescription')))])]), _vm._v(" "), (_vm.$store.getters.config('company_questions_signing') > 0) ? _c('tab', {
    attrs: {
      "name": _vm.$t('help.contactCompany', {
        companyName: _vm.$store.state.clientInfo.company_name
      }),
      "property": "contact-signable-team",
      "id": "3",
      "iconName": "paper-plane"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('help.contactCompany', {
    companyName: _vm.$store.state.clientInfo.company_name
  })))]), _vm._v(" "), (!_vm.messageSent) ? _c('p', [_vm._v(_vm._s(_vm.$t('help.contactFormInfo', {
    companyName: _vm.$store.state.clientInfo.company_name
  })))]) : _vm._e(), _vm._v(" "), (!_vm.messageSent) ? _c('form', {
    staticClass: "help__contact-us"
  }, [_c('textarea', {
    ref: "contact"
  }), _vm._v(" "), _c('app-button', {
    attrs: {
      "text": _vm.$t('functional.send'),
      "iconName": "paper-plane",
      "action": _vm.contact,
      "classList": "float-right"
    }
  })], 1) : _c('message', {
    attrs: {
      "type": "success"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('help.messageSent')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('help.responseInfo')))])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e289ce5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help.vue
// module id = 1049
// module chunks = 1